<template>
    <div>
        <div id="login_welcome">
            <div id="login_welcome_message">{{ $t('System Use Heading') }}</div>
        </div>
        <div id="login_content">
            <div id="login_credentials">
                <p>{{ $t('System Use Description') }}</p>
                <ul v-if="$t('System Use Bullets') !== ''" class="bullet-list">
                    <li v-for="bullet in $t('System Use Bullets').split('\n\n')">{{ bullet }}</li>
                </ul>
            </div>

            <div class="cic-control-bar">
                <CicButton @click="$emit('click')">
                    {{ $t('Accept') }}
                </CicButton>
            </div>
        </div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';

    export default {
        name: 'SystemUse',
        components: {
            CicButton,
        },
        emits: ['click'],
    };
</script>
